import { QueryClient } from '@tanstack/react-query'
import { retryDelayMs, shouldRetryMutation, shouldRetryQuery } from './retry'

/**
 * The app's QueryClient — docs/spec/06 §4 and 01 §5.
 *
 * The retry policy is set HERE, once, and nowhere else. Per-call overrides need
 * a stated reason (06 §4): scattering retry config is how a client ends up
 * retrying a submit and duplicating a transcriber's work.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetryQuery,
        retryDelay: retryDelayMs,
        // 01 §5: on by default so the queue keeps fresh counts. The workspace
        // turns it OFF for a job being edited — refetching under a
        // transcriber's cursor is worse than showing slightly stale data.
        refetchOnWindowFocus: true,
        // Per-query staleTime is specified in 02 §5; no blanket default that
        // would quietly override those.
        staleTime: 0,
      },
      mutations: {
        retry: shouldRetryMutation,
        retryDelay: retryDelayMs,
      },
    },
  })
}
